import { useQuery } from "@tanstack/react-query";
import { getAccountSummaryByDateRange } from "../repositories/SummaryByDateRangeRepository";

export const useAccountSummaryByDateRange = (
	costCenterId: number | null,
	start: string,
	close: string,
) =>
	useQuery({
		queryKey: ["summaryByDateRange", costCenterId, start, close],
		queryFn: ({ signal }) =>
			getAccountSummaryByDateRange(
				costCenterId as number,
				start,
				close,
				signal,
			),
		enabled: costCenterId != null,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
